<template>
  <UAvatar
    alt="admin"
    size="xs"
  />
  <div class="flex flex-col gap-1 justify-start">
    <h3>
      Admin
    </h3>
  </div>
</template>
